(() => {
  const enablePreselection = window.section?.enable_preselection;

  const productVariantsParent = document.querySelector(
    ".js-product-variants-parent"
  );
  const firstGridImage = document.querySelector(
    ".product-media-gallery__grid-image1 img"
  );
  const productImagesJson = document.getElementById("product-images-json");

  function normalizeSrc(src) {
    return src.split("?")[0];
  }

  function switchImage(newImage) {
    if (firstGridImage) {
      firstGridImage.src = newImage.src;
      firstGridImage.srcset = newImage.srcset || "";
    }
  }

  function getDynamicGalleryContainer() {
    return document.querySelector(
      "[class^='product-media-gallery__grid-layout']"
    );
  }

  function hideNonActiveImages(activeImageSrc) {
    const galleryContainer = getDynamicGalleryContainer();
    if (!galleryContainer) return;

    const galleryImages = galleryContainer.querySelectorAll(
      ".product-media-gallery__grid-image img"
    );
    let imageFound = false;

    galleryImages.forEach((img) => {
      const normalizedSrc = normalizeSrc(img.src);
      if (normalizedSrc !== normalizeSrc(activeImageSrc)) {
        img.closest(".product-media-gallery__grid-image").style.display =
          "none";
      } else {
        img.closest(".product-media-gallery__grid-image").style.display = "";
        imageFound = true;
      }
    });

    if (!imageFound && galleryImages.length > 0) {
      galleryImages[0].closest(
        ".product-media-gallery__grid-image"
      ).style.display = "";
    }
  }

  function updateGallery(images, featuredImage) {
    const galleryContainer = getDynamicGalleryContainer();
    const swiperContainer = document.querySelector(
      ".product-media-gallery--mobile .product-media-gallery__swiper-wrapper"
    );

    if (!galleryContainer || !swiperContainer) return;

    galleryContainer.innerHTML = "";
    swiperContainer.innerHTML = "";

    const uniqueImages = new Set();
    const featuredSrc = featuredImage ? normalizeSrc(featuredImage.src) : null;

    let firstImageAdded = false;

    images.forEach((image, index) => {
      const normalizedSrc = normalizeSrc(image.src);
      if (
        !uniqueImages.has(normalizedSrc) &&
        (normalizedSrc !== featuredSrc || !firstImageAdded)
      ) {
        uniqueImages.add(normalizedSrc);
        firstImageAdded = true;

        const desktopImage = `
                <div data-alt="${
                  image.alt || ""
                }" class="product-media-gallery__grid-image js-product-media-gallery__grid-image">
                    <img src="${image.src}" alt="${
          image.alt || ""
        }" loading="eager" class="cover">
                </div>
            `;
        galleryContainer.insertAdjacentHTML("beforeend", desktopImage);

        const mobileImage = `
                <div class="swiper-slide product-media-gallery__swiper-slide js-product-media-gallery__swiper-slide" data-swiper-slide-index="0">
                    <img src="${image.src}" alt="${
          image.alt || ""
        }" loading="eager">
                </div>
            `;
        swiperContainer.insertAdjacentHTML("beforeend", mobileImage);
      }
    });

    const existingLayout = document.querySelector(
      ".product-media-gallery--desktop [class^='product-media-gallery__grid-layout']"
    );
    if (existingLayout) {
      const oldClass = [...existingLayout.classList].find((cls) =>
        cls.startsWith("product-media-gallery__grid-layout")
      );
      if (oldClass) {
        existingLayout.classList.remove(oldClass);
        existingLayout.classList.add("product-media-gallery__grid-layout2");
      }
    }

    const swiperInstance = document.querySelector(
      ".js-product-media-gallery.swiper"
    );
    if (swiperInstance && swiperInstance.swiper) {
      swiperInstance.swiper.update();
    }

    hideNonActiveImages(featuredSrc);
  }

  function handleVariantSwitch(e) {
    const checkedInput = e.target;
    if (checkedInput.checked) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const parsedData = JSON.parse(scriptElement.textContent);
        if (parsedData?.featured_image) {
          switchImage(parsedData.featured_image);
          updateGallery([parsedData.featured_image], parsedData.featured_image);
        }
      }
    }
  }

  function initializeDefaultVariant() {
    const checkedInput = productVariantsParent?.querySelector(
      "input[type='radio']:checked"
    );

    if (checkedInput) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const parsedData = JSON.parse(scriptElement.textContent);
        if (parsedData?.featured_image) {
          switchImage(parsedData.featured_image);
          updateGallery([parsedData.featured_image], parsedData.featured_image);
        }
      }
    } else {
      const productImages = productImagesJson
        ? JSON.parse(productImagesJson.textContent)
        : null;
      if (productImages?.images && productImages.images.length > 0) {
        switchImage(productImages.images[0]);
        updateGallery([productImages.images[0]], productImages.images[0]);
      }
    }
  }

  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      handleVariantSwitch(event);
    });

    document.addEventListener("DOMContentLoaded", initializeDefaultVariant);
  }
})();
